export default __webpack_public_path__ + "static/media/pencil-blue.3e3f154f.svg";